/**
 * TaxIdChip (TMMPDM-0094, tmm-api 0161) — a partner's tax-ID status at pay-api, shown beside the tax
 * documents status wherever an agreement shows it. The tone is the registry's (`StatusChip`, TMM-B2):
 * VERIFIED → success, PENDING → info, MISMATCH → warning (it needs the partner's action),
 * NOT_REQUIRED → neutral. Absent or `null` (a partner without a pay-api payee) renders nothing. The
 * server publishes the payout hold; the console composes none from this and the tax documents.
 * A status this console doesn't know renders neutrally with its raw value rather than throwing.
 */
import { useCopy } from '@/hooks/useCopy';
import { StatusChip } from '@/status';
import { TAX_ID_STATUSES, type TaxIdStatus } from '@/api/tmm/types';

const TAX_ID_FALLBACK: Record<TaxIdStatus, string> = {
  NOT_REQUIRED: 'Not required',
  PENDING: 'Pending',
  VERIFIED: 'Verified',
  MISMATCH: 'Mismatch',
};

export function TaxIdChip({ status }: { status: string | null | undefined }) {
  const { t } = useCopy();
  if (status === undefined || status === null) return null;
  if (!(TAX_ID_STATUSES as readonly string[]).includes(status)) {
    return <StatusChip label={status} />;
  }
  return (
    <StatusChip
      status={status}
      label={t(`resellers.agreement.taxId.${status}`, TAX_ID_FALLBACK[status as TaxIdStatus])}
    />
  );
}
